import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerBlack, tannerGray } from '../colors';

type MuiBreadcrumbs = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiBreadcrumbs'];
  defaultProps?: ComponentsProps['MuiBreadcrumbs'];
  variants?: ComponentsVariants['MuiBreadcrumbs'];
};

export const MuiBreadcrumbs: MuiBreadcrumbs = {
  styleOverrides: {
    root: {
      li: {
        a: {
          color: tannerGray[700],
          svg: {
            verticalAlign: 'sub',
            marginRight: '3px',
            color: tannerGray[600],
            height: '17px',
          },
          '&:hover': {
            color: tannerBlack,
            svg: {
              color: tannerBlack,
            },
          },
          '&:active': {
            color: tannerGray[800],
            svg: {
              color: tannerGray[800],
            },
          },
        },
        p: {
          color: tannerGray[700],
        },
      },
    },
  },
};
